import { Component, Input } from '@angular/core';
import { GoogleAd } from 'src/app/core/enums';
import { environment as env } from 'src/environments/environment';

@Component({
	selector: 'app-google-ad',
	templateUrl: './google-ad.component.html',
	styleUrls: ['./google-ad.component.scss'],
})
export class GoogleAdComponent {
	@Input() type: GoogleAd;

	readonly googleAd = GoogleAd;
	readonly googleAdBanner = env.GOOGLE_ADSENSE.banner;
	readonly googleAdFeed = env.GOOGLE_ADSENSE.feed;
	readonly googleAdMultiplex = env.GOOGLE_ADSENSE.multiplex;
	readonly isEnabled = env.GOOGLE_ADSENSE.isEnabled;
}
